<!-- 由 woniu6162 创建于 2021-10-21 星期四 -->
<template>
  <div class="p-head">
    <img :src="bgPic" class="ir_h_bg" />
    <div class="ir_h_date" @click="tapOption">
      <div class="ir_hd_name">时间</div>
      <div class="ir_hd_info">{{ curRange }}</div>
      <i class="iconfont iconxiala" />
    </div>
    <!-- 时间：选择器 -->
    <van-popup v-model="showTime" position="bottom" round get-container="app">
      <van-datetime-picker
        v-model="real_date"
        type="year-month"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="showTime = false"
        @confirm="confirmTime"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'p-head',

  mixins: [],

  components: {},

  props: {
    datum: {}
  },

  data() {
    return {
      showTime: false,
      minDate: new Date(2021, 8, 9),
      maxDate: new Date(),
      real_date: this.datum.date,
      bgPic: 'https://cdnvue.gymcity.com.cn/uploads/inner_rank_bg'
    }
  },

  computed: {
    curRange() {
      let date = this.datum.date
        ? this.formatRange(new Date(this.datum.date))
        : this.formatRange(new Date())
      return date
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    tapOption() {
      this.showTime = true
    },
    // 确认：时间选择器
    confirmTime(val) {
      this.showTime = false
      this.datum.date = this.formatDate(val)
    },
    // 格式化,开始时间：时间选择器
    formatDate(val) {
      var year = val.getFullYear()
      var mon = val.getMonth() + 1
      var date = val.getDate()
      if (mon < 10) mon = '0' + mon
      if (date < 10) date = '0' + date
      var postDate = `${year}/${mon}/${date}`
      return postDate
    },
    // 格式化,月份：显示
    formatRange(val) {
      var year = val.getFullYear()
      var mon = val.getMonth() + 1
      // var date = val.getDate()
      if (mon < 10) mon = '0' + mon
      // if (date < 10) date = "0" + date
      var postDate = `${year}年${mon}月`
      return postDate
    },
    // 时间选择器：格式化
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.p-head {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .ir_h_bg {
    width: 100%;
    object-fit: cover;
  }
  .ir_h_date {
    position: absolute;
    bottom: 5.3vw;
    width: 91.7vw;
    height: 9.9vw;
    padding: 0 5.3vw 0 3.2vw;
    box-sizing: border-box;
    background-color: #f7f7f7;
    border-radius: 1.1vw;
    display: flex;
    align-items: center;
    background: #fff;
    .ir_hd_name {
      min-width: fit-content;
      font-size: 3.5vw;
      color: rgba(0, 0, 0, 0.5);
    }
    .ir_hd_info {
      text-align: left;
      width: 100%;
      padding-left: 5.3vw;
      font-size: 3.5vw;
      font-weight: 600;
      color: #000;
    }
    & > i {
      font-size: 2.4vw;
      color: #ccc;
    }
  }
}
</style>
